/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Category_Create_SuccessInputs */

const vi_product_category_create_success = /** @type {(inputs: Product_Category_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thêm danh mục`)
};

/**

* @param {Product_Category_Create_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_category_create_success = /** @type {((inputs?: Product_Category_Create_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Category_Create_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_category_create_success(inputs)
});